'use strict';

var GetIntrinsic = require('get-intrinsic');

var $Math = GetIntrinsic('%Math%');
var $Number = GetIntrinsic('%Number%');

module.exports = $Number.MAX_SAFE_INTEGER || $Math.pow(2, 53) - 1;



/*****************
 ** WEBPACK FOOTER
 ** ./~/es-abstract/helpers/maxSafeInteger.js
 ** module id = 2892
 ** module chunks = 0
 **/